export function assetOrUndef<T>(
  record: Record<string, string | number>,
  test = '',
): T | undefined {
  if (test in record) {
    return record[test] as unknown as T
  }
}
